
export default route => {
  window.scrollTo(0, 0) // 跳转后返回页面顶部
}
